import React, { useState, useEffect, useRef } from "react";
import { BsBriefcase } from "react-icons/bs";
import { HiOutlineLocationMarker } from "react-icons/hi";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import OurBlogs from "../pages/OurBlogs";
import "../App.css";
import service1 from "../assets/career_0.webp";
import service2 from "../assets/career_1.webp";
import service3 from "../assets/career_2.webp";
import service4 from "../assets/career_3.webp";
import service5 from "../assets/career_4.webp";
import AboutUsBannerMobile from "../assets/career_banner_mobile.webp";
import AboutUsBanner from "../assets/career_banner.webp";
import useLazyImage, {
  LazyImageComponent,
} from "../components/lazyloader/LazyImage";

const allJobs = [
  {
    title: "Frontend Developer",
    department: "IT Engineering",
    experience: "2–3 years",
    location: "Noida",
  },
  {
    title: "Backend Developer",
    department: "IT Engineering",
    experience: "2–3 years",
    location: "Noida",
  },
  {
    title: "Financial Analyst",
    department: "Finance",
    experience: "2–3 years",
    location: "Noida",
  },
  {
    title: "Marketing Specialist",
    department: "Marketing",
    experience: "2–3 years",
    location: "Noida",
  },
  {
    title: "Sales Representative",
    department: "Sales",
    experience: "2–3 years",
    location: "Noida",
  },
  {
    title: "DevOps Engineer",
    department: "IT Engineering",
    experience: "2–3 years",
    location: "Noida",
  },
  {
    title: "Account Manager",
    department: "Sales",
    experience: "2–3 years",
    location: "Noida",
  },
  {
    title: "Content Strategist",
    department: "Marketing",
    experience: "2–3 years",
    location: "Noida",
  },
];

const categories = ["All", "IT Engineering", "Finance", "Marketing", "Sales"];

const Career = () => {
  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [activeFilter, setActiveFilter] = useState("All");

  const filteredJobs =
    activeFilter === "All"
      ? allJobs
      : allJobs.filter((job) => job.department === activeFilter);

  const scrollContainerRef = useRef(null);
  const [scrollDirection, setScrollDirection] = useState("right");
  const scrollSpeed = 1;

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    let animationId;

    const scroll = () => {
      const maxScrollLeft =
        scrollContainer.scrollWidth - scrollContainer.clientWidth;
      const currentScrollLeft = scrollContainer.scrollLeft;

      if (
        currentScrollLeft >= maxScrollLeft - 5 &&
        scrollDirection === "right"
      ) {
        setScrollDirection("left");
      } else if (currentScrollLeft <= 5 && scrollDirection === "left") {
        setScrollDirection("right");
      }

      scrollContainer.scrollLeft +=
        scrollDirection === "right" ? scrollSpeed : -scrollSpeed;

      animationId = requestAnimationFrame(scroll);
    };

    animationId = requestAnimationFrame(scroll);

    return () => {
      cancelAnimationFrame(animationId);
    };
  }, [scrollDirection]);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth > 768 && windowWidth <= 1024;

  const bannerImage = isMobile ? AboutUsBannerMobile : AboutUsBanner;
  const { ref, loadedSrc } = useLazyImage(bannerImage);

  return (
    <>
      <section className="w-100 position-relative mb-5">
        <div className="container-fluid p-0">
          <div
            ref={ref}
            className="position-relative w-100 d-flex hero-banner"
            style={{
              minHeight:
                windowWidth <= 767
                  ? "520px" // Mobile
                  : windowWidth <= 1024
                  ? "340px" // Tablet
                  : windowWidth <= 1600
                  ? "500px" // Medium Desktop
                  : "750px", // Large Desktop
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundImage: loadedSrc ? `url(${loadedSrc})` : "none",
              alignItems: windowWidth <= 768 ? "flex-start" : "center",
              paddingTop: windowWidth <= 768 ? "40px" : "0",
            }}
          >
            {/* Overlay */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 1,
              }}
            ></div>

            <div className="container-fluid">
              <div className="row align-items-center">
                <div className="col-1"></div>
                <div
                  className="col-10"
                  style={{
                    position: "relative",
                    zIndex: 2,
                    width:
                      windowWidth <= 768
                        ? "90%"
                        : windowWidth <= 1024
                        ? "42%"
                        : "45%",
                    textAlign: windowWidth <= 768 ? "center" : "left",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: windowWidth <= 768 ? "center" : "flex-start",
                  }}
                >
                  <div className="text-gray text-start">
                    <h1
                      className="fw-semibold mb-2"
                      style={{
                        fontSize:
                          windowWidth <= 768
                            ? "22px"
                            : windowWidth <= 1024
                            ? "24px"
                            : "35px",
                        textAlign: "left",
                        lineHeight: "1.2",
                        fontWeight: "700",
                      }}
                    >
                      Delivers Expert Financial
                      <br /> Solutions for Growth.
                    </h1>
                    <p
                      className="mb-4"
                      style={{
                        fontSize:
                          windowWidth <= 768
                            ? "16px"
                            : windowWidth <= 1024
                            ? "16px"
                            : "18px",
                        textAlign: "left",
                        maxWidth: "400px",
                        marginTop: "-5px",
                      }}
                    >
                      Explore opportunities in finance and innovation.
                    </p>
                  </div>
                </div>
                <div className="col-1"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="our-beginnings mt-5 mb-2"
        style={{
          background:
            "linear-gradient(180deg, rgba(255,255,255,1) 0%, #F3F0FF 60%, rgba(255,255,255,1) 100%)",
        }}
      >
        <div className="container-fluid p-0">
          <div className="row">
            <div className="col-1 d-none d-lg-block"></div>
            <div className="col-12 col-lg-10">
              <div className="row align-items-center">
                {/* TEXT */}
                <div
                  className="col-12 col-lg-6 mb-5 order-1 order-lg-1"
                  style={{
                    textAlign: windowWidth <= 768 ? "center" : "left",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: windowWidth <= 768 ? "center" : "flex-start",
                  }}
                >
                  <h4
                    className="fw-semibold mb-3 text-center text-sm-start text-lg-start px-3 px-sm-4 px-lg-0"
                    style={{ fontSize: "32px" }}
                  >
                    Life at Shubh Paisa
                  </h4>

                  <p className="text-center text-sm-start text-lg-start px-3 px-sm-4 px-lg-0">
                    At Shubh Paisa, we believe in fueling ambitions and
                    nurturing talent. We're more than just a financial services
                    company — we're a team driven by trust, innovation, and
                    excellence.
                  </p>

                  <p className="text-center text-sm-start text-lg-start px-3 px-sm-4 px-lg-0">
                    Join us in our mission to make finance simple, secure, and
                    accessible for everyone across India. If you’re passionate
                    about creating impact, driving change, and shaping the
                    future of financial solutions, we welcome you to explore
                    opportunities with us and be a part of our journey.
                  </p>

                  {/* cards */}
                  <div className="row g-4 mt-3 w-100 align-items-stretch">
                    <div className="col-12 col-sm-4">
                      <div className="card p-3 text-start  h-100 border-0">
                        <h6 className="fw-semibold">
                          A Workplace That Inspires
                        </h6>
                        <p className="mb-0">
                          Collaborative, dynamic, and driven by purpose.
                        </p>
                      </div>
                    </div>

                    <div className="col-12 col-sm-4">
                      <div className="card p-3 text-start h-100 border-0">
                        <h6 className="fw-semibold">Growth Beyond Limits</h6>
                        <p className="mb-0">
                          Training, mentorship, and endless learning
                          opportunities.
                        </p>
                      </div>
                    </div>

                    <div className="col-12 col-sm-4">
                      <div className="card p-3 text-start h-100 border-0">
                        <h6 className="fw-semibold">A Culture of Impact</h6>
                        <p className="mb-0">
                          Work that transforms lives and futures.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* IMAGE */}
                <div className="col-12 col-lg-6 mb-4 order-2 order-lg-2 d-flex justify-content-center">
                  <LazyImageComponent
                    src={service1}
                    alt="Life at Shubh Paisa"
                    style={{
                      width: "100%",
                      maxWidth: "600px",
                      height: "430px",
                      objectFit: "cover",
                      borderRadius: "12px",
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="col-1 d-none d-lg-block"></div>
          </div>
        </div>
      </section>

      <div className="container-fluid px-0 mb-5 mt-lg-4 mt-2">
        <div className="row g-0">
          <div className="col-12 col-sm-6 col-md-3">
            <div className="position-relative overflow-hidden career-image-container">
              <LazyImageComponent
                src={service2}
                alt="Career 2"
                className="w-100 h-100"
                style={{ objectFit: "cover", objectPosition: "center" }}
              />
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-3">
            <div className="position-relative overflow-hidden career-image-container">
              <LazyImageComponent
                src={service3}
                alt="Career 3"
                className="w-100 h-100"
                style={{ objectFit: "cover", objectPosition: "center" }}
              />
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-3">
            <div className="position-relative overflow-hidden career-image-container">
              <LazyImageComponent
                src={service4}
                alt="Career 4"
                className="w-100 h-100"
                style={{ objectFit: "cover", objectPosition: "center" }}
              />
            </div>
          </div>

          <div className="col-12 col-sm-6 col-md-3">
            <div className="position-relative overflow-hidden career-image-container">
              <LazyImageComponent
                src={service5}
                alt="Career 5"
                className="w-100 h-100"
                style={{ objectFit: "cover", objectPosition: "center" }}
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className="container-job position-relative"
        style={{
          background: "linear-gradient(90deg, #7A7AD2 0%, #CACAFF 100%)",
          overflow: "hidden",
        }}
      >
        <div className="position-relative py-5" style={{ zIndex: 1 }}>
          <div className="container" style={{ maxWidth: "1200px" }}>
            <h2 className="text-center mb-4 fw-semibold">
              Join The Family, <br className="d-block d-sm-none" /> We're
              Hiring!
            </h2>

            <div className="category-scroll-wrapper mb-4">
              <div
                className="category-scroll px-2"
                ref={scrollContainerRef} // auto-scroll container
              >
                <div className="scroll-inner">
                  {categories.map((category, index) => (
                    <button
                      key={index}
                      className={`btn rounded-pill border ${
                        activeFilter === category
                          ? "btn-primary text-white"
                          : "btn-light text-dark"
                      }`}
                      onClick={() => setActiveFilter(category)}
                    >
                      {category}
                    </button>
                  ))}
                </div>
              </div>

              <div className="job d-flex justify-content-center">
                <div className="row w-100 gx-3 gy-3 justify-content-center mt-3">
                  {filteredJobs.slice(0, 8).map((job, index) => (
                    <div className="col-12 col-md-6 col-lg-6" key={index}>
                      <div
                        className="card border-0 h-100"
                        style={{
                          backgroundColor: "rgba(255, 255, 255, 0.8)",
                          backdropFilter: "blur(12px)",
                          WebkitBackdropFilter: "blur(12px)",
                          borderRadius: "1rem",
                          boxShadow:
                            "0px 8px 30px rgba(0, 0, 0, 0.05), 0px 2px 12px rgba(0, 0, 0, 0.03)",
                          padding: "1rem",
                        }}
                      >
                        <div className="d-flex flex-column flex-md-row justify-content-center align-items-center text-center text-md-start gap-3">
                          <div className="w-100 mt-2">
                            <h5 className="fw-semibold mb-2">{job.title}</h5>
                            <p className="text-muted mb-1 d-flex justify-content-center justify-content-md-start align-items-center">
                              <BsBriefcase size={18} className="me-2" />
                              {job.experience}
                            </p>
                            <p className="text-muted mb-0 d-flex justify-content-center justify-content-md-start align-items-center">
                              <HiOutlineLocationMarker
                                size={18}
                                className="me-2"
                              />
                              {job.location}
                            </p>
                          </div>

                          <div className="text-center text-md-end w-100">
                            <Link
                              to="/job-modal"
                              className="btn bg-primary text-white fw-semibold d-inline-flex align-items-center justify-content-center rounded-4 mt-2 px-3"
                              style={{
                                fontSize: "0.875rem",
                                whiteSpace: "nowrap",
                                fontFamily: "poppins",
                              }}
                            >
                              Apply Now{" "}
                              <i className="fas fa-arrow-right ms-2 mt-1"></i>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <OurBlogs />
    </>
  );
};

export default Career;
